import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    markCollected: {
        show: false,
        data: [],
    },
    markNotCollected: {
        show: false,
        data: [],
    },
    addStillage: {
        show: false,
        data: [],
    }
};

export const stillageCollections = createSlice({
    name: 'stillageCollections',
    initialState,
    reducers: {
        openModal: (state, action) => {
            const { payload: { key, data } } = action;
            if (state[key]) {
                state[key].show = true;
                state[key].data = { ...data };
            }
        },
        closeModal: (state) => {
            state.addStillage.show = false;
            state.markNotCollected.show = false;
            state.markCollected.show = false;
        },
        updateData: (state, action) => {
            const { payload: { key, data } } = action;
            if (state[key]) {
                state[key].data = { ...data };
            }
        }
    }
});

// Action creators are generated for each case reducer function
export const { openModal, closeModal, updateData } = stillageCollections.actions;

export default stillageCollections.reducer;